import { render, staticRenderFns } from "./User.vue?vue&type=template&id=8f473ac4&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
import style0 from "./User.vue?vue&type=style&index=0&id=8f473ac4&prod&lang=css"
import style1 from "./User.vue?vue&type=style&index=1&id=8f473ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f473ac4",
  null
  
)

export default component.exports